import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import YuJaButton from "../../components/standardization/YuJaButton";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import useMobileAccess from '../../hooks/useMobileAccess';
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {
    BUTTON,
    SEARCH_BOX_PLACEHOLDER, SEARCH_POLL,
    SEARCH_TEXT,
} from '../../utils/constants';
import { notifyError } from '../../utils/helpers';
import { LOADING_FILTER_ERROR, LOADING_SEARCH_ERROR } from '../../utils/toast-message-constants';
import styles from "./ManagePolls.module.css";
import "./styles.css";
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import classes from "../Report/Report.module.css";
import {Button} from "@base-ui/react/button";


export default function RecycleBinSearchForm({handleSubmit, showButton, handleDelete, handleRestore, disabled=false, collapsed=false}) {
    const filterRef = useRef();
    const filterMenuRef = useRef();
    const isNarrow = useRef(useMobileAccess(1200));
    // const windowDimensions = useWindowDimensions();
    const [keyword, setKeyword] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [modeFilter, setModeFilter] = useState([]);
    const [statusFilter, setStatusFilter] = useState([]);
    const [oldCollapsed, setOldCollapsed] = useState(false);
    const [filterMenuDimensions, setFilterMenuDimensions] = useState({});
    const [filterMenuLocation, setFilterMenuLocation] = useState({x: 0, y: 0});
    // const [smallScreen, setSmallScreen] = useState(window.innerWidth < 1200);

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && filterMenuRef.current && !filterMenuRef.current.contains(event.target) && !filterRef.current.contains(event.target)) {
                setShowFilterMenu(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (showFilterMenu && (oldCollapsed !== collapsed || filterMenuDimensions.width === 0 || JSON.stringify(filterMenuDimensions) !== JSON.stringify(filterMenuRef?.current?.getBoundingClientRect()))) {
            console.log(isNarrow.current, collapsed, filterRef?.current?.getBoundingClientRect(), filterMenuRef?.current?.getBoundingClientRect());
            setFilterMenuDimensions(filterMenuRef?.current?.getBoundingClientRect());
            setOldCollapsed(collapsed);
            resetFilterMenuPosition();
        }
    }, [collapsed, filterMenuRef?.current?.getBoundingClientRect()]);

    const clickSearch = ({key=keyword, start=startDate, end=endDate, mode=modeFilter, status=statusFilter}) => {
        if (disabled) {
            notifyError(LOADING_SEARCH_ERROR);
            return;
        }
        let formattedStartDate = start ? start.split("-").reverse().join("-") : "";
        let formattedEndDate = end ? end.split("-").reverse().join("-") : "";
        handleSubmit({
            keyword: key,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            mode: mode,
            status: status
        });
    };

    const clickFilter = () => {
        if (disabled) {
            notifyError(LOADING_FILTER_ERROR);
            return;
        }
        setShowFilterMenu(!showFilterMenu);
    };

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch({});
        }
    };

    const resetFilterMenuPosition = () => {
        const filterRect = filterRef?.current?.getBoundingClientRect();
        // const filterMenuRect = filterMenuRef?.current?.getBoundingClientRect();
        // console.log(filterRect, filterMenuRect, window.scrollX, window.scrollY);
        // const x = filterRect?.left + window.scrollX - ( window.innerWidth <= 1200 ? 0 : ((filterMenuRect?.width - filterRect?.width) / 2 + 20 - (filterMenuRect?.width / 2) + (collapsed ? 60 : 240)));
        const x = -filterRect?.width - 10;
        // const y = filterRect?.bottom + window.scrollY - 52 + (5);
        const y = 25;
        // console.log(x, y);
        setFilterMenuLocation({x, y});
    };

    const onApply = (filterOptions) => {
        setModeFilter(filterOptions.optionFilter1);
        setStatusFilter(filterOptions.optionFilter2);
        setStartDate(filterOptions.dateFilter1);
        setEndDate(filterOptions.dateFilter2);
        clickSearch({
            start: filterOptions.dateFilter1,
            end: filterOptions.dateFilter2,
            mode: filterOptions.optionFilter1,
            status: filterOptions.optionFilter2
        });
    };

    return (
        <div style={{width: "100%"}}>
                    <div className={styles.searchBox}>
                        <Form className={styles.searchBoxForm} onSubmit={e => e.preventDefault()}
                        >
                            {/* <div ref={filterRef} style={{position: "relative", display: "inline"}}>
                                <Filter className={`${styles.focusIcon}`} tabIndex={0} onMouseDown={e => e.preventDefault()} aria-label={FILTER_POLLS} onClick={clickFilter} style={{width: 32, height: 32}} />
                            </div>
                            <div style={{position: "relative"}}>
                            <div
                                ref={filterMenuRef}
                                style={{
                                    position: "absolute",
                                    top: filterMenuLocation.y + "px",
                                    left: filterMenuLocation.x + "px",
                                }}
                            >
                                <FilterMenu
                                    show={showFilterMenu}
                                    setShow={setShowFilterMenu}
                                    onApply={onApply}
                                    filterOptions={{
                                        optionFilter1Name: POLL_TYPE_HEADER,
                                        optionFilter1: modeFilter,
                                        optionsFilter1: [MERGED_MODE, ATTENDANCE],
                                        optionFilter2Name: STATUS_LABEL,
                                        optionFilter2: statusFilter,
                                        optionsFilter2:  [UNFINISHED, READY_TO_SHARE, SHARED_BY_QUESTION, SHARED_ENTIRELY, SCHEDULED],
                                        dateFilter1Name: START_DATE,
                                        dateFilter1: startDate,
                                        dateFilter2Name: END_DATE,
                                        dateFilter2: endDate
                                    }}
                                />
                            </div>
                            </div> */}
                            <YuJaTextBox
                                label={SEARCH_POLL}
                                containerStyle={{fontSize: 15, lineHeight: 1.5, marginLeft: 10, marginRight: 10}}
                                placeholder={SEARCH_BOX_PLACEHOLDER}
                                onChange={e => setKeyword(e.target.value)}
                                onKeyUp={enterKeyup}
                                value={keyword}
                                before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                                after={
                                    !!keyword
                                        ? (
                                            <Button
                                                aria-label={"Clear search keyword"}
                                                className={classes.closeIcon}
                                                onClick={() => {
                                                    setKeyword("");
                                                    clickSearch({key: ""});
                                                }}
                                            >
                                                <CLOSE style={{width: 16, height: 16}}/>
                                            </Button>
                                        )
                                        : (<></>)
                                }
                            />

                            <YuJaButton onClick={clickSearch}><div style={{fontSize: 14, lineHeight: 1.6,}}>{SEARCH_TEXT}</div></YuJaButton>
                    {showButton &&
                        <>
                            <YuJaButton onClick={() => {handleRestore()}}>
                                <div style={{fontSize: 14, lineHeight: 1.6, width: "120px"}}> Restore selected</div>
                            </YuJaButton>
                            <YuJaButton type="delete" onClick={() => {handleDelete()}}>
                                <div style={{fontSize: 14, lineHeight: 1.6, width: "110px"}}> Delete Selected </div>
                            </YuJaButton>
                        </>
                    }
                        </Form>
                    </div>
        </div>
    );
}